/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'gm-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    standalone: false
})
export class HeaderComponent implements OnInit {
	@Input() sidebarOpen: boolean;
	@Output() openSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
	currentDate: Date = new Date();
  userLanguageSession = sessionStorage.getItem("userLanguageSetting");

	constructor(private translateService: TranslateService) {
    if (this.userLanguageSession != undefined) {
      translateService.setDefaultLang(this.userLanguageSession);
    }
    else {
      let language = translateService.currentLang;
      if (language==undefined) language='en';
      if (language.indexOf('en')<0 && language.indexOf('pt')<0 && language.indexOf('ch')<0 && language.indexOf('ko')<0){
        sessionStorage.setItem("userLanguageSetting",'en');
      }
      else{
        if (language.indexOf('en')>=0)
          language='en';
        sessionStorage.setItem("userLanguageSetting",language);
      }
      translateService.setDefaultLang(language);
    }

  }

	ngOnInit() {
	}

	toggleSidebar(): void{
		this.sidebarOpen = !this.sidebarOpen;
		this.openSidebar.emit(this.sidebarOpen);
	}

  public switchLanguage(event) {
    let fireboxFix = event.target || event.srcElement;
    let language = (<HTMLSelectElement>fireboxFix).value;
	  this.translateService.use(language);
    sessionStorage.setItem("userLanguageSetting",language);
  }
}
